<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>App Users List</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>

            <div class="card p-mt-1">
                <DataTable :value="clientRoles" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ localAdminName || '-' }}</h6>
                        </template>
                    </Toolbar>
                    <TabView v-model:activeIndex="activeTab" @tab-change="onTabChange">
                        <TabPanel header="App Users"></TabPanel>
                        <TabPanel header="App Installations"></TabPanel>
                    </TabView>

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>

                    <Column headerStyle="width: 2%" class="align-center"></Column>

                    <Column header="Sr. no" field="sr_no" headerStyle="width: 7%" style="overflow-wrap: break-word"
                        class="justify-center align-center">
                        <template #body="{ index }">
                            <span>{{ index + 1 + (page_no * 30) }}</span>
                        </template>
                    </Column>

                    <Column header="App Usage Date" field="ad151" class="p-text-capitalize" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span>{{ format_datetime(data.ad151) }}</span>
                        </template>
                    </Column>

                    <Column header="Mobile Brand / Model Name" field="ad134" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ad135 ? data.ad135 : '-' }} </span>
                            <hr/>
                            <span>{{ data.ad134 ? data.ad134 : '-' }}</span>
                        </template>
                    </Column>

                    <Column header="Mobile OS Version" field="ad138" headerStyle="width: 12%">
                        <template #body="{ data }">
                            <span>{{ data.ad138 ? data.ad138 : '-' }}</span>
                        </template>

                    </Column>

                    <Column header="Name" field="ad9" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ad9 ? data.ad9 : '-' }}</span>
                            <div>
                                <span class="p-text-secondary">{{ data.ad15 ? data.ad15 : '-' }}</span>
                            </div>
                        </template>
                    </Column>

                    <Column header="App Installation Date" field="ad137" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span>{{ format_datetime_stamp(data.ad137) }}</span>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import router from '@/router';
import CommonMixins from '../../mixins/common-mixins';

export default {
    mixins: [CommonMixins],
    data() {
        return {
            clientRoles: [],
            v$: useValidate(),
            loading: false,
            page_no: 0,
            totalRecords: 0,
            localAdminName: '',
            routeParam: '',
            activeTab: 0, // 0 = App Users, 1 = App Installations
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.getAppUsageByUsersList();
    },
    methods: {
        async getAppUsageByUsersList(page = 0) {
            this.loading = true;
            const payload = {
                maa1: this.routeParam,
                is_app_usages_voters: this.activeTab === 0 ? 0 : 1,
                page_no: page,
            };
            this.ApiService.getAppUsageByUsersList(payload)
                .then((response) => {
                    if (response && response.data) {
                        this.clientRoles = response.data;
                        this.totalRecords = response.count;
                    } else {
                        this.clientRoles = [];
                        this.totalRecords = 0;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.clientRoles = [];
                    this.totalRecords = 0;
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
        },

        onPage(event) {
            this.page_no = event.page;
            this.getAppUsageByUsersList(event.page);
        },

        onTabChange() {
            this.page_no = 0; // reset to first page when tab changes
            this.getAppUsageByUsersList(0);
        },

        goToDashboard() {
            router.push({
                name: 'admindashboard',
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: 'AppPopupSettings',
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: 'AppVersionSetting',
                params: { adminSubId: this.routeParam },
            });
        },
    },
};
</script>
